class DZModelDemandBase {

    /**
     * 主键
     */
    id = "";

    /**
     * 需求标题
     */
    title = "";

    /**
     * 列表图片ID
     */
    listCoverId = "";


    /**
     * 土地大类ID
     */
    bigType = "";

    /**
     * 土地小类ID
     */
    smallType = "";

    /**
     * 详细地址ID
     */
    addressId = "";

    /**
     * 流转年限
     */
    movePeriod = "";

    /**
     * 土地面积从
     */
    areaFrom = "";

    /**
     * 土地面积至
     */
    areaTo = "";

    /**
     * 土地面积单位ID
     */
    areaUnit = "";

    /**
     * 期望价格从
     */
    priceFrom = "";

    /**
     * 期望价格至
     */
    priceTo = "";

    /**
     * 价格单位ID
     */
    priceUnit = "";

    /**
     * 流转类型ID
     */
    moverType = "";

    /**
     * 补充说明
     */
    describe = "";

    /**
     * 联系人ID
     */
    contactsId = "";

    /**
     * 发布状态：0-待审核，1-审核通过，2-审核未通过
     */
    status = "";

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelDemandBase